import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

function LoadingSpinner() {
    return (
        <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--background-base)' }}>
            <div className="flex flex-col items-center gap-4">
                <Loader2 className="w-10 h-10 animate-spin" style={{ color: 'var(--primary-color)' }} />
                <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>Loading...</p>
            </div>
        </div>
    );
}

export function ProtectedRoute({ children, requireAdmin = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) return <LoadingSpinner />;
    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

    if (requireAdmin && user.role !== 'admin') {
        return <Navigate to="/dashboard" replace />;
    }

    // Students of any status get in — pending/rejected see the locked preview experience

    return children;
}

export function StatusRoute({ children, status }) {
    // Used for pending/rejected pages - only show if user has that status
    const { user, loading } = useAuth();
    if (loading) return <LoadingSpinner />;
    if (!user) return <Navigate to="/login" replace />;

    if (user.role === 'admin') return <Navigate to="/admin" replace />;
    // Pending/rejected users now land on the locked dashboard instead of waiting/rejected rooms
    return <Navigate to="/dashboard" replace />;
}

export function PublicRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) return <LoadingSpinner />;

    if (user) {
        if (user.role === 'admin') return <Navigate to="/admin" replace />;
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}
